import React, { useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';

const RulesPopup = ({ isOpen, onClose, bonusTitle, rules = [], scrollable = true }) => {
  const { t } = useTranslation();

  // Body scroll lock effect
  useEffect(() => {
    if (isOpen) {
      // Popup açıldığında body scroll'unu kilitle
      document.body.classList.add('body-scroll-lock');
      // iOS Safari için ek optimizasyon
      document.documentElement.style.overflow = 'hidden';
      
      // Popup açıldığında content'i en üste scroll yap (sadece scrollable true ise)
      if (scrollable) {
        const contentElement = document.querySelector('.rules-popup-content');
        if (contentElement) {
          contentElement.scrollTop = 0;
        }
      }
    } else {
      // Popup kapandığında body scroll'unu serbest bırak
      document.body.classList.remove('body-scroll-lock');
      document.documentElement.style.overflow = '';
    }

    // Cleanup function
    return () => {
      document.body.classList.remove('body-scroll-lock');
      document.documentElement.style.overflow = '';
    };
  }, [isOpen, scrollable]);
  
  if (!isOpen) return null;

  return (
    <div className="rules-popup-overlay">
      <div className="rules-popup">
        <div className="rules-popup-header">
          <h3>{bonusTitle}</h3>
          <button 
            className="close-button"
            onClick={onClose}
          >
            ✕
          </button>
        </div>
        
        <div className={`rules-popup-content ${scrollable ? 'scrollable' : 'no-scroll'}`}>
          <h4 className="rules-popup-subtitle">{t('popup.rulesTitle', 'Kurallar ve Koşullar')}</h4>
          
          <div className="rules-list">
            {rules && rules.length > 0 ? (
              rules.map((rule, index) => (
                <div key={index} className="rule-item">
                  <div className="rule-number">{index + 1}</div>
                  <div className="rule-content">
                    <h5 className="rule-title">{rule.title}</h5>
                    <p className="rule-text">
                      {rule.metin.split('\n').map((textPart, i) => (
                        <React.Fragment key={i}>
                          {textPart}
                          {i < rule.metin.split('\n').length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-rules">
                <p>{t('popup.noRules', 'Bu bonus için henüz kural belirtilmemiştir.')}</p>
              </div>
            )}
          </div>
        </div>
        
        <div className="rules-popup-footer">
          <button className="rules-close-button" onClick={onClose}>
            {t('buttons.close', 'Kapat')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesPopup; 